import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface SectionSeparatorProps {
  type?: 'wave' | 'curve' | 'gradient' | 'dots';
  flip?: boolean;
}

const SectionSeparator: React.FC<SectionSeparatorProps> = ({ type = 'wave', flip = false }) => {
  const { colors } = useTheme();

  const getSeparator = () => {
    switch (type) {
      case 'wave':
        return (
          <svg
            className={`w-full h-20 ${flip ? 'transform rotate-180' : ''}`}
            viewBox="0 0 1440 100"
            preserveAspectRatio="none"
          >
            <path
              d="M0,50 C150,100 350,0 600,50 C850,100 1050,0 1300,50 C1450,100 1440,50 1440,50 L1440,100 L0,100 Z"
              fill={colors.primary.main}
              fillOpacity="0.1"
            />
            <path
              d="M0,60 C200,20 400,80 700,60 C1000,40 1200,100 1440,60 L1440,100 L0,100 Z"
              fill={colors.accent.mint}
              fillOpacity="0.1"
            />
          </svg>
        );
      
      case 'curve':
        return (
          <svg
            className={`w-full h-16 ${flip ? 'transform rotate-180' : ''}`}
            viewBox="0 0 1440 100"
            preserveAspectRatio="none"
          >
            <path
              d="M0,100 Q720,0 1440,100 L1440,100 L0,100 Z"
              fill={colors.background.accent}
            />
          </svg>
        );
      
      case 'gradient':
        return (
          <div
            className={`w-full h-32 ${flip ? 'transform rotate-180' : ''}`}
            style={{
              background: `linear-gradient(to bottom, transparent, ${colors.background.default})`,
            }}
          />
        );
      
      case 'dots':
        return (
          <div className="w-full py-8 flex justify-center items-center space-x-2">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="w-2 h-2 rounded-full animate-pulse"
                style={{
                  backgroundColor: colors.accent.mint,
                  animationDelay: `${i * 0.1}s`,
                  opacity: 0.3 + (i * 0.15)
                }}
              />
            ))}
          </div>
        );
      
      default:
        return null;
    }
  };

  return <div className="w-full overflow-hidden">{getSeparator()}</div>;
};

export default SectionSeparator;